const customerReviews = document.querySelectorAll('.customer-reviews');

customerReviews.forEach(section => {

    const customerReviewsItemsContainer = section.querySelector('.customer-reviews__items');
    const customerReviewsItems = section.querySelectorAll('.item');
    const customerReviewsDotsContainer = section.querySelector('.dots');
    const customerReviewsControlsBtns = section.querySelectorAll('.controls .btn');

    let customerReviewSlide = 1;
    
    /* DOTS */

    function createCustomerReviewsDots(){
        for(let i=0;i<customerReviewsItems.length;i++){
            const newDot = document.createElement('div');
            newDot.id = i+1;
            newDot.classList.add('dot');
            if(i==0){
                newDot.classList.add('active');
            }
            newDot.innerHTML = '<div class="round"></div>';
            customerReviewsDotsContainer.appendChild(newDot);
        }
    }
    createCustomerReviewsDots();

    function updateCustomerReviewsDots(){
        const customerReviewsDots = section.querySelectorAll('.dots .dot');

        for(let i=0;i<customerReviewsDots.length;i++){
            if(customerReviewsDots[i].id == customerReviewSlide){
                customerReviewsDots[i].classList.add('active');
            }else{
                customerReviewsDots[i].classList.remove('active');
            }
        }
    }

    /* CONTROLS */

    function updateCustomerReviewSlide(){

        let slideWidth;

        if(window.innerWidth < 750){
            slideWidth = customerReviewsItemsContainer.clientWidth+20;
        }else{
            slideWidth = customerReviewsItemsContainer.clientWidth;
        }

        customerReviewsItemsContainer.style.transform = `translateX(-${(slideWidth)*(customerReviewSlide-1)}px)`;
    }

    customerReviewsControlsBtns.forEach(button => {
        button.addEventListener('click', () => {
            if(button.id == 'left'){
                if(customerReviewSlide == 1){
                    customerReviewSlide = customerReviewsItems.length;
                }else{
                    customerReviewSlide--;
                }
            }else if(button.id == 'right'){
                if(customerReviewSlide == customerReviewsItems.length){
                    customerReviewSlide = 1;
                }else{
                    customerReviewSlide++;
                }
            }
            updateCustomerReviewSlide();
            updateCustomerReviewsDots();
        })
    })

})